import { ModelBase, Property, Required, ShortString } from '@skylab-shared/core';

export class ProductGroupModel extends ModelBase {
    @Property({ identifiable: true })
    public externalId: string;

    @Property()
    public isDefault: boolean;

    @Property()
    @ShortString('data-model.product-group.validation.name.length')
    @Required('data-model.product-group.validation.name.no-empty')
    public name: string;
}
